export const TestIds = {
  PayScheduleNavigator: 'payschedule-navigator',
  PayScheduleNavigatorCount: 'payschedule-navigator-count',
};
